module.exports = __webpack_public_path__ + "media/old_images/default-image-activity-orange-8e8b6f9a.png";